import * as R from 'ramda';
import styled from 'styled-components';

import { getScreenSize, getThemeColor, getThemeFont, getThemeSize } from '../../../utils/theme';
import { Text } from '../common';

export const CompanyCardWrapS = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  border-radius: 3px;
  word-break: break-all;
  box-shadow: 2px 0px 10px rgba(112, 157, 199, 0.25);
  transition: background-color 0.3s linear;

  &:hover {
    & > div:first-child {
      background-color: ${getThemeColor(['darkerViolet'])};
    }
    box-shadow: 3px 0px 11px rgba(0, 0, 0, 0.3);
    background-color: ${getThemeColor(['greyLight'])};
    cursor: pointer;
  }
`;

export const CompanyLogoWrapS = styled.div`
  position: relative;
  display: ${({ mobile }) => (mobile ? 'none' : 'block')};
  background-color: ${getThemeColor(['grayBlue'])};
  border-radius: 3px 0 0 3px;
  transition: background-color 0.5s linear;

  @media (max-width: ${getScreenSize(['medium'])}) {
    display: ${({ mobile }) => (mobile ? 'inline-block' : 'none')};
    margin-right: 10px;
  }
`;

export const CompanyLogoImageWrap = styled.div`
  display: flex;
  border-radius: 50%;

  background: ${getThemeColor(['white'])} url(${({ logo }) => logo}) center no-repeat;
  background-size: ${R.propOr('auto', 'bz')};

  margin: 10px;
  width: 81.8px;
  height: 81.8px;
  justify-content: center;
  align-items: center;
`;

export const CompanySpecialOfferImageWrap = styled.img`
  position: absolute;
  top: 50%;
  left: -30px;
  transform: translateY(-50%);
  width: 150px;
  height: 46px;

  @media (max-width: ${getScreenSize(['medium'])}) {
    position: static;
    top: 0;
    left: 0;
    transform: none;
  }
`;

export const CompanyHeaderWrapS = styled.div`
  width: 100%;
  padding: 10px 30px;
  display: flex;
  flex-direction: column;
  border-bottom: 2px solid ${getThemeColor(['grayBlue'])};
`;

export const CompanyHeaderS = styled.h2`
  min-height: 50px;
  flex-grow: 1;

  display: flex;
  align-items: center;
`;

export const ContentCompanyWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 16px 40px 33px 30px;
`;

export const TagInfoWrapper = styled.div`
  display: flex;
  align-items: start;
  margin-bottom: 10px;

  & img {
    margin-right: 10px;
  }

  & svg {
    margin: 2px 10px 0 2px;
    color: ${getThemeColor(['violet'])};
    font-size: ${getThemeSize(['bigText'])};
  }

  & span {
    white-space: nowrap;
  }

  @media (max-width: ${getScreenSize(['medium'])}) {
    margin-bottom: 10px;
  }
`;

export const InfoWrapperS = styled.div`
  margin-bottom: 16px;

  &:last-of-type {
    margin-bottom: 0;

    @media (max-width: ${getScreenSize(['medium'])}) {
      margin-bottom: 16px;
    }
  }
`;

export const InfoTitleItemHeaderS = styled(Text)`
  color: ${getThemeColor(['violet'])};
  font-size: ${getThemeSize(['bigText'])};
  font-family: ${getThemeFont(['bold'])};
  padding-right: 5px;
`;

export const InfoBodyS = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  margin: 0 -9px;
`;

export const InfoBodyItemS = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin: 9px 9px 0;
  padding: ${({ round }) => (round ? '5px 13px' : '0')};
  background: ${({ backgroundColor }) => (backgroundColor ? getThemeColor([backgroundColor]) : 'transparent')};
  border-radius: ${({ round }) => (round ? '14px' : '0')};
`;

export const MobileCompanyCardWrapS = styled.div`
  box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  background-color: ${getThemeColor(['white'])};
`;

export const CompanyMobileHeaderS = styled.div`
  display: flex;
  background: ${getThemeColor(['grayBlue'])};
  padding: 22px 7px;
  flex-direction: row;
  align-items: center;
`;

export const CompanyLogoS = styled.img`
  width: 63px;
  height: 63px;
  border-radius: 50%;
  margin-right: 12px;
`;

export const CompanyNameS = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 5px;

  & h4 {
    font-size: ${getThemeSize(['mediumText'])};
    font-weight: 700;
    line-height: 15.6px;
    text-align: center;
    color: ${getThemeColor(['violet'])};
    text-align: left;
  }
`;

export const VerifiedIconS = styled.img`
  margin-left: 3px;
  width: 17px;
  height: 17px;
`;

export const RatingSectionS = styled.div`
  .rating-container {
    display: flex;
    flex-direction: column-reverse;

    & > div {
      align-items: center;
      margin: 0 !important;
      display: flex;
      flex-direction: row;

      & img {
        width: 15px;
        height: 15px;
        margin-right: 6px;
      }

      & span {
        margin: 0 3px 0 0;
        font-size: ${getThemeSize(['smallText'])};
        font-weight: 400;
        line-height: 24px;
        text-align: center;
      }

      & svg {
        width: 13px;
        height: 13px;
      }
    }
  }
`;

export const ContactInfoS = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px;
  margin-bottom: 7px;
`;

export const ContactItemS = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

export const ContactIconS = styled.img`
  margin-right: 13px;
  width: 20px;
  height: 20px;
`;

export const ContactTextS = styled.span`
  font-size: ${getThemeSize(['mediumText'])};
  font-weight: 400;
  line-height: 15.6px;
  text-align: left;
  color: ${getThemeColor(['darkerViolet'])};
`;

export const ServiceTitleS = styled.div`
  font-family: ${getThemeFont(['regular'])};
  font-size: ${getThemeSize(['mediumText'])};
  font-weight: 700;
  line-height: 15.6px;
  text-align: left;
  margin-right: 19px;
  color: ${getThemeColor(['darkerViolet'])};
`;

export const ServicesSectionS = styled.div`
  padding: 0 12px;
  display: flex;
  margin-bottom: 10px;

  & ${ServiceTitleS}:last-of-type {
    margin-right: 11px;
  }
`;

export const ServiceListS = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
`;

export const ServiceItemS = styled.li`
  font-size: ${getThemeSize(['smallText'])};
  font-family: ${getThemeFont(['regular'])};
  font-weight: 400;
  line-height: 13.2px;
  text-align: left;
  margin-right: 10px;
  color: ${getThemeColor(['greyViolet'])};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  
  @media (max-width: ${getScreenSize(['medium'])}) {
    color: ${getThemeColor(['primary'])};
  }
`;

export const MemberItemS = styled.li`
  font-size: ${getThemeSize(['smallText'])};
  font-family: ${getThemeFont(['regular'])};
  font-weight: 400;
  line-height: 13.2px;
  text-align: left;
  margin-right: 10px;
  color: ${getThemeColor(['greyViolet'])};
  white-space: nowrap;
`;

export const ViewsSectionS = styled.div`
  font-family: ${getThemeFont(['regular'])};
  font-size: ${getThemeSize(['smallText'])};
  font-weight: 400;
  line-height: 24px;
  text-align: right;
  color: ${getThemeColor(['violet'])};
  margin-right: 13px;
`;

export const InfoSectionS = styled.div`
  & :last-child {
    margin-bottom: 6px;
  }
`;
